import { axiosInstance, axiosMultipart } from "@/axios/interceptors.ts";
import { parseRequestError, instanceOfError } from "@/axios/utils.ts";
import { ZodSentryReporter } from "@/lib/zod-sentry-reporter";
import { z } from "zod";

const FileUploadResponse = z.object({
	file_name: z.string(),
});

const FaceRegistrationResponse = z.object({
	error_status: z.number(),
	message: z.string(),
});

export type requestProps = {
	imageBlob: Blob;
	guest_id: number;
	guest_registration_id: number;
};

export const registerFace = async ({
	imageBlob,
	guest_id,
	guest_registration_id,
}: requestProps) => {
	try {
		const uploadFileForm = new FormData();
		uploadFileForm.append("file", imageBlob);
		const fileUploadResponse = await axiosMultipart.post(
			"/global/upload-file",
			uploadFileForm,
		);
		const fileName = ZodSentryReporter.parse(
			FileUploadResponse,
			fileUploadResponse,
		).file_name;

		const registrationResponse = await axiosInstance.post(
			"/trueface/template/insert",
			{
				guest_id,
				guest_registration_id,
				image_name: fileName,
			},
		);
		ZodSentryReporter.parse(FaceRegistrationResponse, registrationResponse);
		return;
	} catch (err) {
		// The error object (e.g. { code: 11020, message: "The selfie provided is too blurry..." })
		// is neither a ZodError nor an AxiosError, so parseRequestError() currently return a generic
		// fallback message which is "An unexpected error occurred....".
		// but instanceOfError() checks if it matches the { code, message,
		// details } format then throw directly so the user sees the actual API error message.
		if (instanceOfError(err)) {
			throw err;
		}
		throw parseRequestError(err);
	}
};
